import type { FC } from "react";

import { LoyaltyPushBlock as LoyaltyPushBlockUI } from "@jti/loyalty";

import { usePageConfig } from "@/context/PageConfigContext";

import { LoyaltyVideoPreview } from "../LoyaltyVideoPreview/LoyaltyVideoPreview";
import { mapPushBlockProps } from "../PushBlock/utils/mapPushBlockProps";

import type { loyaltyPushBlockInputs } from "./LoyaltyPushBlock.builder";

export type LoyaltyPushBlockBuilderProps = BuilderComponentProps<typeof loyaltyPushBlockInputs>;

export const LoyaltyPushBlock: FC<LoyaltyPushBlockBuilderProps> = ({
  desktopImage,
  mobileImage,
  alt = "",
  orientation,
  title,
  subtitle,
  description,
  cta,
  href,
  containedCTA,
  smallHeightOnMobile,
  trackingEvent,
  mobileOrientation,
  logo,
  blockContentProperties,
  secondButton,
  theme = "inherit",
  ctaLogged,
  hrefLogged,
  ctaRestricted,
  hrefRestricted,
  enableVideo,
  videoPreview,
}) => {
  const { darkMode } = usePageConfig();

  const props = mapPushBlockProps({
    desktopImage,
    mobileImage,
    alt,
    orientation,
    title,
    subtitle,
    description,
    cta,
    href,
    containedCTA,
    smallHeightOnMobile,
    trackingEvent,
    mobileOrientation,
    logo,
    blockContentProperties,
    secondButton,
    theme,
    darkMode,
  });

  const renderMedia = enableVideo && videoPreview ? <LoyaltyVideoPreview {...videoPreview} fullHeight /> : undefined;

  return (
    <LoyaltyPushBlockUI
      {...props}
      ctaLogged={ctaLogged}
      hrefLogged={hrefLogged}
      ctaRestricted={ctaRestricted}
      hrefRestricted={hrefRestricted}
      renderMedia={renderMedia}
    />
  );
};
